import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {JwtService} from './jwt.service';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient,
              private jwt: JwtService,
              private router: Router) {
  }

  public login(email: string, password: string) {
    return this.http.post('/auth/login', {email, password}).map((res: any) => {
      console.log(res);
      if (res.success) {
        this.jwt.setToken(res.auth_token);
      }
      return res.success;
    });
  }

  public logout() {
    this.jwt.clearToken();
    this.router.navigate(['/auth/login']);
  }

}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/services/auth.service.ts